module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG6e983b5e2471ed1c5f7024c22ef5c273.6e983b5e.png";